import RequestService from "@/services/request.service";
import { AppError } from "@/services/error.service";
import { clone } from "@/plugins/query";

const PartnersService = {
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/List%20Partners
  getAll: async function (organizationId, eventId, filters) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/`;
      return await RequestService.get(path, filters);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/Retrieve%20Partners
  get: async function (organizationId, eventId, partnerId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/${partnerId}/`;
      return await RequestService.get(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  _preparePartner: function (data) {
    const payload = clone(data);
    if (payload.guest_group) payload.guest_group = payload.guest_group.id;
    return payload;
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/Create%20Partners
  create: async function (organizationId, eventId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/`;
      return await RequestService.post(path, this._preparePartner(data));
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/Update%20Partners
  update: async function (organizationId, eventId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/${data.id}/`;
      return await RequestService.put(path, this._preparePartner(data));
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/v1_organizations_events_partners_destroy
  delete: async function (organizationId, eventId, partnerId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/${partnerId}/`;
      return await RequestService.delete(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/Export%20Partners
  export: async function (organizationId, eventId, filters = { file_format: "csv" }) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/export/`;
      return await RequestService.getBlob(path, filters);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/Import%20Partners
  import: async function (organizationId, eventId, file) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/import/`;
      return await RequestService.postFile(path, file);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/Send%20Invite%20Link
  sendInviteLink: async function (organizationId, eventId, partnerId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/${partnerId}/send-invite-link/`;
      return await RequestService.post(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/Send%20Bulk%20Invite%20Links
  sendBulkInviteLinks: async function (organizationId, eventId, data, params) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/send-bulk-invite-links/`;
      return await RequestService.post(path, data, params);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/Get%20Content%20Configuration
  getPartnersContentConfiguration: async function (organizationId, eventId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/content-configuration/`;
      return await RequestService.get(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/Save%20Content%20Configuration
  updatePartnersContentConfiguration: async function (organizationId, eventId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/content-configuration/`;
      return await RequestService.post(path, data);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Partners/Download%20Import%20Template%20CSV%20for%20Partners
  downloadImportTemplate: async function (organizationId, eventId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/partners/download-import-template/`;
      return await RequestService.getBlob(path);
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default PartnersService;
